import React from 'react'
import { AddendumModel } from '../../capacity.model'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { getCustomerDomain } from '../../../../redux'
import {
  DataTable,
  DataTableSkeleton,
  DataTableOptions,
  FilterType,
  DataType,
  DataTableColumn
} from '@globaleris/ui.library'
import { useTheme, makeStyles } from '@material-ui/core'
import { styles } from './addendumCard.styles'

export const AddendumsCard: React.FC<{ addendums: AddendumModel[] | undefined }> = ({
  addendums
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'addendumsCard', 'enums'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const columns = useMemo((): DataTableColumn[] => {
    return [
      {
        name: 'quantity',
        label: t('addendumsCard:dataTable.columns.quantity'),
        type: DataType.NUMBER
      },
      {
        name: 'initDate',
        label: t('addendumsCard:dataTable.columns.initDate'),
        type: DataType.DATE
      },
      {
        name: 'endDate',
        label: t('addendumsCard:dataTable.columns.endDate'),
        type: DataType.DATE
      },
      {
        name: 'signDate',
        hideForResponsive: true,
        label: t('addendumsCard:dataTable.columns.signDate'),
        type: DataType.DATE
      },
      {
        name: 'bonusDiff',
        hideForResponsive: true,
        label: t('addendumsCard:dataTable.columns.bonusDiff'),
        type: DataType.NUMBER
      }
    ]
  }, [])

  const options: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    elevation: 1,
    search: true,
    filterType: FilterType.ADVANCED,
    download: true,
    print: false,
    selectableRows: false,
    customInsertEditModal: true,
    canEdit: false,
    canDelete: false,
    analytics: {
      customer: getCustomerDomain(),
      view: t('addendumsCard:dataTable.analytics')
    }
  }

  if (!addendums) {
    return <DataTableSkeleton elevation={0} rows={5}></DataTableSkeleton>
  }

  return (
    <div className={classes.addendumsCard}>
      <DataTable
        title={t('addendumsCard:dataTable.title')}
        data={addendums}
        columns={columns}
        options={{
          ...options,
          analytics: {
            customer: getCustomerDomain(),
            view: t('addendumsCard:dataTable.analytics')
          }
        }}
        // info={DataTableErrorHandler(errorProps)}
        // userPermissions={getUserPermissions(Pages.Capacities)}
        // appliedFilter={dataTableFilter}
        // appliedSearch={dataTableSearch}
      />
    </div>
  )
}
